// Google Analytics 4. Paste the Measurement ID (looks like G-XXXXXXXXXX) from
// analytics.google.com > Admin > Data streams. While it's empty, nothing loads.
export const GA_ID = '';

let loaded = false;
window.dataLayer = window.dataLayer || [];
function gtag() {
  window.dataLayer.push(arguments);
}

// Queue events right away; the Google script itself loads on the first
// interaction or after 5 seconds, so it never slows down the first view.
export function trackEvent(name, params = {}) {
  if (GA_ID) gtag('event', name, params);
}

function loadGtag() {
  if (loaded || !GA_ID) return;
  loaded = true;
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);
}

export function initAnalytics(router) {
  if (!GA_ID) return;
  gtag('js', new Date());
  // Page views are sent from the router below, since this is a single-page app.
  gtag('config', GA_ID, { send_page_view: false });

  ['pointerdown', 'keydown', 'scroll', 'touchstart'].forEach((type) =>
    window.addEventListener(type, loadGtag, { once: true, passive: true })
  );
  setTimeout(loadGtag, 5000);

  router.afterEach((to) => {
    gtag('event', 'page_view', {
      page_path: to.fullPath,
      page_location: window.location.origin + to.fullPath,
      page_title: document.title
    });
  });

  // Phone taps anywhere on the site count as leads.
  document.addEventListener('click', (event) => {
    const link = event.target.closest && event.target.closest('a[href^="tel:"]');
    if (link) {
      trackEvent('phone_call_click', { phone_number: link.getAttribute('href').replace('tel:', '') });
    }
  });
}
